
import { Route } from 'react-router-dom';
import './App.css';
import Dashbo from './Dashboa';
import { BrowserRouter, Routes } from 'react-router-dom';
import Login from './Login';
import Withdra from './Withdra';

function App() {

  return (
    <div>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Login></Login>}></Route>
          <Route path='/dash' element={<Dashbo></Dashbo>}></Route>
          <Route path='/withdraw' element={<Withdra></Withdra>}></Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}


export default App;
